import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">Lakics Márk EV</h3>
            <p className="footer-tagline">Minőség. Precizitás. Otthon.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Navigáció</h4>
              <ul>
                <li><Link to="/">Főoldal</Link></li>
                <li><Link to="/rolam">Rólam</Link></li>
                <li><Link to="/galeria">Galéria</Link></li>
                <li><Link to="/kapcsolat">Kapcsolat</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Szolgáltatások</h4>
              <ul>
                <li>Belső festés</li>
                <li>Tapétázás</li>
                <li>Glettelés</li>
                <li>Díszítő festés</li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Kapcsolat</h4>
              <ul>
                <li><a href="tel:+36309869878">+36309869878</a></li>
                <li><a href="mailto:info@lakicsfesto.com">info@lakicsfesto.com</a></li>
                <li>Győr és környéke</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Lakics Márk. Minden jog fenntartva.</p>
          <div className="legal-links">
            <Link to="/adatvedelem">Adatvédelem</Link>
            <span className="separator">•</span>
            <Link to="/impresszum">Impresszum</Link>
            <span className="separator">•</span>
            <Link to="/aszf">ÁSZF</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
